module.exports = __webpack_public_path__ + "img/CoreDeForce.d6390382.jpg";